// --- Intercept add.js XHR to inject _selected_skus ---
(function() {
  var _lastSelectedSkus = '';

  window._etUpdateSkus = async function() {
    // console.log(11111)
    if (!window.expivi) return;
    // console.log(2222)
    var attrs = await window.expivi.getProductAttributes();
    _lastSelectedSkus = attrs
      .filter(function(a) {
        return a.type === 'question' && a.visible !== false
          && a.attribute_values && a.attribute_values.length > 0;
      })
      .map(function(a) {
        const sel = a.attribute_values.find(v => v.id === a.selected_value_id);
        if (!sel?.key) return null;
        if (sel.key.startsWith('att-')) return null;
        return sel.key;
      })
      .filter(Boolean)
      .join(',');
  };

  window._etGetSelectedSkus = function() {
    return _lastSelectedSkus;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._etUrl = url;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    if (this._etUrl && this._etUrl.indexOf('add.js') !== -1 && body) {
      try {
        var data = JSON.parse(body);
        if (!data.properties) data.properties = {};
        data.properties['_selected_skus'] = _lastSelectedSkus;
        body = JSON.stringify(data);
        console.log('[ET] Injected _selected_skus into add.js:', _lastSelectedSkus);
      } catch (e) {
        console.log('[ET] add.js body is not JSON, trying FormData');
      }
    }
    return origSend.call(this, body);
  };
})();

document.addEventListener('DOMContentLoaded', function() {
  if (!window.expivi) {
    return;
  }

  var infoPanel = document.querySelector('#expivi-info-panel');
  if (infoPanel) {
    infoPanel.style.display = 'flex';
  }

  // --- Keep _selected_skus updated ---
  window.expivi._events.onReady.subscribe(function() {
    window._etUpdateSkus();
  });

  window.expivi._events.onChange.subscribe(function(e) {
    if (e.name === 'attribute' || e.name === 'buildupdated') {
      window._etUpdateSkus();
    }

    if (e.name === "fully_loaded") {
      var preloader = document.getElementById('product-preloader');
      if (preloader) {
        preloader.style.display = 'none';

        var preloaderText = preloader.querySelector('.preloader-text');
        var lottiePlayer = document.getElementById('lottie-animation-element');

        if (preloaderText) {
          preloaderText.innerHTML = "ONE SEC!<br>WE'RE LOADING...";
        }

        if (lottiePlayer && typeof lottiePlayer.load === 'function') {
          lottiePlayer.load('https://lottie.host/f804d56d-66d8-4b62-a057-5aecf4e81ce4/YTgQW2NMYw.lottie');
        }
      }
    }
  });

  // --- Log attributes with keys for debugging ---
  window.expivi.getProductAttributes().then(function(attrs) {
    var selections = attrs
      .filter(function(a) {
        return a.type === 'question' && a.visible !== false
          && a.attribute_values && a.attribute_values.length > 0;
      })
      .map(function(a) {
        var sel = a.attribute_values.find(function(v) { return v.id === a.selected_value_id; });
        if (!sel || !sel.key || sel.key === '-') return null;
        return { Attribute: a.name, Selected: sel.name, Key: sel.key };
      })
      .filter(Boolean);
    console.table(selections);
  });

  // --- Add to cart preloader ---
  var addToCartButton = document.querySelector('.expivi-add-to-cart');
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function() {
      var preloader = document.getElementById('product-preloader');
      var preloaderText = preloader.querySelector('.preloader-text');
      var lottiePlayer = document.getElementById('lottie-animation-element');

      if (preloader && preloaderText && lottiePlayer) {
        preloaderText.innerHTML = 'ONE SEC!<br>ADDING TO CART...';

        if (typeof lottiePlayer.load === 'function') {
          lottiePlayer.load('https://lottie.host/4b9976d6-e393-4f43-bbfb-4e92ea5ef5a4/MrQM73wRdp.lottie');
        }

        preloader.style.display = 'flex';

        setTimeout(function() {
          if (preloader.style.display === 'flex') {
            preloader.style.display = 'none';
            preloaderText.innerHTML = "ONE SEC!<br>WE'RE LOADING...";
            lottiePlayer.load('https://lottie.host/f804d56d-66d8-4b62-a057-5aecf4e81ce4/YTgQW2NMYw.lottie');
          }
        }, 7000);
      }
    });
  }
});




// window.expivi.getProductAttributes().then(function(attrs) {
//       console.log(22222, attrs)
//       var selections = attrs
//       .filter(function(a) {
//         return a.type === 'question' && a.visible === true
//       && a.attribute_values && a.attribute_values.length > 0;
//     })
//     .map(function(a) {
//       var sel = a.attribute_values.find(function(v) { return v.id === a.selected_value_id; });
//       if (!sel) return null;
//         return { Attribute: a.name, Selected: sel.name, Key: sel.key || '-', ID: sel.id };
//       })
//       .filter(Boolean);
//       console.table(selections);
//     });

//     async function getSelectedSKUs() {
//       var attrs = await window.expivi.getProductAttributes();
//       return attrs
//       .filter(function(a) {
//         return a.type === 'question' && a.visible === true
//         && a.attribute_values && a.attribute_values.length > 0;
//       })
//       .map(function(a) {
//     var sel = a.attribute_values.find(function(v) { return v.id === a.selected_value_id; });
//     if (!sel) return null;
//     return sel.key || String(sel.id);
//     })
//     .filter(Boolean)
//     .join(',');
//     }
// window.xpv_filter_add_to_cart = function(options) {
//   console.log(getSelectedSKUs())
  
//       getSelectedSKUs().then(function(skus) {
//         window.expivi.setProductAttribute()
//       options['_selected_skus'] = skus;
//       });
//       return options;
//   };

// });



